<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-start mb-3" v-if="sharedSails">
      <h3 class="title ml-3">Ortak Tarihli Turlar</h3>
      <a v-for="sharedSail in sharedSails" target="_blank" :href="'/sails/'+sharedSail.id" class="theme-btn theme-btn-transparent mr-5 ml-4" :class="sharedSail.state === 0 ? 'beforeSail' : 'afterSail'" style="height: 50px;color: whitesmoke; margin-top: auto">
        <span aria-hidden="true" class="la la-sync-alt"> {{sailsLiteMap[sharedSail.id].sailDate | ddMMyyyy}}</span>
      </a>
    </div>
<!--    <div class="mr-2 sea-tour-port-list-hour-input">-->
    <div class="row mb-3" style="width: 100%">
      <button @click="resetFilters" type="button" class="theme-btn theme-btn-transparent theme-btn-danger-rgb mr-5 ml-4" style="height: 50px;color: indianred; margin: auto">
        <span aria-hidden="true" class="la la-close"> Seçimi Sıfırla</span>
      </button>
<!--      <base-select-input-->
<!--          v-model="selectedAgency"-->
<!--          :optionList="agencyList"-->
<!--          class="mr-4"-->
<!--          :label="'Rezerve edilen Acente'">-->
<!--      </base-select-input>-->
      <v-app>
        <div class="input-box mr-4">
          <label class="label-text">Rezerve Edilen Acente</label>
        <v-autocomplete
            :filter="filterAgenciesEmail"
            class="pl-4 mb-10"
            :items="agencyList"
            v-model="selectedAgency"
            hide-details
            item-value="id"
            placeholder="Agency">
          <template slot="selection" slot-scope="{ item, selected }">
            <!--                                  {{item.roomNumber}} {{item.ros ? '(ROS)' : ''}} - {{  getRoomName(item.roomId) }}-->
            {{item.name}}
          </template>
          <template slot="item" slot-scope="{ item, tile }">
            <!--                                  <v-list-tile-content>-->
            {{item.name}}
            <!--                                  </v-list-tile-content>-->
          </template>
        </v-autocomplete>
        </div>
      </v-app>
      <base-select-input
          v-model="selectedRoom"
          :optionList="roomList"
          :label="'Oda Tipi'">
      </base-select-input>
<!--      <div class="input-box justify-content-end ml-5" style="width: auto">-->
<!--        <label class="label-text row" style="font-weight: bold;">Rezerve : </label>-->
<!--        <label class="label-text row" style="font-weight: bold;">Rezerve ( Çapraz ) : </label>-->
<!--        <label class="label-text row" style="font-weight: bold;">Bloke : </label>-->
<!--        <label class="label-text row" style="font-weight: bold;">Bloke ( Acente )</label>-->
<!--      </div>-->
      <div class="input-box justify-content-end ml-5" style="width: auto">
        <div class="mt-1" style="display: flex; align-items: center;">
          <div style="width: 20px; height: 20px; background-color: #0da33e; margin-right: 5px;"></div>
          <label class="label-text row ml-1" style="font-weight: bold;">Müsait : {{cruiseRoomCounts.emptyCount}}</label>
        </div>
        <div class="mt-1" style="display: flex; align-items: center;">
          <div style="width: 20px; height: 20px; background-color: #0da33e; margin-right: 5px;"></div>
          <label class="label-text row ml-1" style="font-weight: bold;">Rezerve : {{cruiseRoomCounts.reservedCount}}</label>
        </div>
        <div class="mt-1" style="display: flex; align-items: center;">
          <div style="width: 20px; height: 20px; background-color: #b4b4b4; margin-right: 5px;"></div>
          <label class="label-text row ml-1" style="font-weight: bold;">Bloke : {{cruiseRoomCounts.blockedCount}}</label>
        </div>
        <div class="mt-1" style="display: flex; align-items: center;">
          <div style="width: 20px; height: 20px; background-color: darkorange; margin-right: 5px;"></div>
          <label class="label-text row ml-1" style="font-weight: bold;">Bloke ( Acente ) : {{cruiseRoomCounts.agencyBlockedCount}}</label>
        </div>
      </div>
      <div class="input-box justify-content-end ml-5" style="width: auto">
        <div class="mt-1" style="display: flex; align-items: center;">
          <div style="width: 20px; height: 20px; background-color: #f0de38; margin-right: 5px;"></div>
          <label class="label-text row ml-1" style="font-weight: bold;">Rezerve ( Çapraz ) : {{cruiseRoomCounts.sharedBookedCount}}</label>
        </div>
        <div v-for="sharedSail in sharedSails" class="mt-1" style="display: flex; align-items: center;">
          <div :style="sharedSail.state === 0 ? 'background-color: #d13c6f;' : 'background-color: #964ba3;'" style="width: 20px; height: 20px; margin-right: 5px;"></div>
          <label class="label-text row ml-1" style="font-weight: bold;">Rezerve ( {{sailsLiteMap[sharedSail.id].sailDate | ddMMyyyy}} ) : {{sharedSail.state === 0 ? cruiseRoomCounts.beforeSailCount : cruiseRoomCounts.afterSailCount}}</label>
        </div>
      </div>
    </div>
<!--    </div>-->

    <div v-for="deck in decks" >
      <div  class="deck-wrapper" v-if="deckHasRoom(deck)">
        <h5>{{deck.name}}</h5>
          <div v-for="cruiseRoom in cruiseRoomList">
            <button data-toggle="tooltip" type="button" data-placement="top" class="room"
                    @click="detailClick(cruiseRoom)"
                    v-if="cruiseRoom.deckId === deck.id && checkFilter(cruiseRoom)"
                    :class="getRoomCellType(cruiseRoom)"
                    :title="getTitle(cruiseRoom)">
              {{cruiseRoom.roomNumber}}
            </button>
  <!--          <button data-toggle="tooltip" type="button" data-placement="top" class="room blocked" @click="detailClick(cruiseRoom)" v-if="((cruiseRoom.deckId == deck.id) && cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.reservedAgencyId === 0 )" :title="getTitle(cruiseRoom)">-->
  <!--            {{cruiseRoom.roomNumber}}-->
  <!--          </button>-->
  <!--          <button data-toggle="tooltip" type="button" style="background: darkorange;" data-placement="top" class="room blocked" @click="detailClick(cruiseRoom)" v-if="((cruiseRoom.deckId == deck.id) && cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.reservedAgencyId !== 0 )" :title="getTitle(cruiseRoom)">-->
  <!--            {{cruiseRoom.roomNumber}}-->
  <!--          </button>-->
  <!--          <button data-toggle="tooltip" type="button" data-placement="top" class="room empty" @click="detailClick(cruiseRoom)" v-if="((cruiseRoom.deckId == deck.id) && !cruiseRoom.bookingDetail.isBooked && !cruiseRoom.bookingDetail.blocked)" :title="getTitle(cruiseRoom)">-->
  <!--            {{cruiseRoom.roomNumber}}-->
  <!--          </button>-->
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import BaseSelectInput from "../base/BaseSelectInput";
export default {
  name: "SailDeckList",
  components: {BaseSelectInput},
  data:function (){
    return{
      selectedAgency: null,
      selectedRoom: null,
      cruiseRoomCounts : {
        emptyCount : 0,
        reservedCount : 0,
        sharedBookedCount : 0,
        blockedCount : 0,
        agencyBlockedCount : 0,
        beforeSailCount : 0,
        afterSailCount : 0
      }
    }
  },
  computed:{
    roomList:{
      get(){
        if(!this.$store.getters.getRoomList){
          return []
        }
        let roomList = JSON.parse(JSON.stringify(this.$store.getters.getRoomList));

        // roomList.push({
        //   id : null,
        //   name: "Seçimi Kaldır."
        // })
        return roomList;
      }
    },
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList;
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    userListMap:{
      get(){
        return this.$store.getters.getUserListMap;
      }
    },
    sailList:{
      get(){
        return this.$store.getters.getSailsLite;
      }
    },
    decks(){
      // return this.$store.getters.getDeckList;
      let deckList = this.$store.getters.getDeckList;
      if(!deckList) return null;
      deckList = deckList.sort( (a, b) => {

        try{
          return (parseInt(a.order) > parseInt(b.order)) ? 1 : -1;
        }catch (ex){
          return -1
        }
      })

      return deckList;
    },
    cruiseRoomList(){
      // return this.$store.getters.getCruiseRoomList
      let cruiseRoomList = this.$store.getters.getCruiseRoomList;
      if(cruiseRoomList === null) return
        cruiseRoomList = cruiseRoomList.sort( (a, b) => {

        try{
          return (parseInt(a.roomNumber) > parseInt(b.roomNumber)) ? 1 : -1;
        }catch (ex){
          return -1
        }
      })

      return cruiseRoomList;
    },
    sharedSails:{
      get() {
        if(!this.cruiseRoomList){
          return [];
        }
        let sharedSails = []
        for (let i = 0; i < this.cruiseRoomList.length; i++) {
          if (this.cruiseRoomList[i].bookingDetail && this.cruiseRoomList[i].bookingDetail.sharedAvailabilities) {
            for (let j = 0; j < this.cruiseRoomList[i].bookingDetail.sharedAvailabilities.length; j++) {

              if(sharedSails.filter(sharedSail=>{
                return sharedSail.id === this.cruiseRoomList[i].bookingDetail.sharedAvailabilities[j].sailId;
              }).length === 0){
              // if (sharedSails.indexOf(this.cruiseRoomList[i].bookingDetail.sharedAvailabilities[j].sailId) === -1) {
                sharedSails.push({id: this.cruiseRoomList[i].bookingDetail.sharedAvailabilities[j].sailId})
              }
            }
          }
        }

        for(let i = 0; i < sharedSails.length; i ++){
          switch (i){
            case 0:
              sharedSails[i].state = 0;
              break;
            case 1:
              sharedSails[i].state = 1;
              break;
            default:

          }
        }

        return sharedSails;
      }
    },
    sailsLiteMap:{
      get(){
        return this.$store.getters.getSailsLiteMap;
      }
    },
    roomListMap(){
      return this.$store.getters.getRoomListMap
    }
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
    setTimeout(()=> {
      this.onCruiseRoomListChanged();
    },5000)
  },
  methods:{
    onCruiseRoomListChanged(){
      let cruiseRooms = this.cruiseRoomList;

      let emptyCount = 0;
      let reservedCount = 0;
      let blockedCount = 0;
      let agencyBlockedCount = 0;
      let beforeSailCount = 0;
      let afterSailCount = 0;
      let sharedBookedCount = 0;

      for (let cruiseRoomsKey in cruiseRooms) {
        let cruiseRoom = cruiseRooms[cruiseRoomsKey];

        if(!this.checkFilter(cruiseRoom)) continue;

        switch (this.getRoomCellType(cruiseRoom)){
          case "empty" : emptyCount++; break;
          case "full" : reservedCount++; break;
          case "blocked" : blockedCount++; break;
          case "reservedToAgency" : agencyBlockedCount++; break;
          case "beforeSail" : beforeSailCount++; break;
          case "afterSail" : afterSailCount++; break;
          case "sharedBooked" : sharedBookedCount++; break;
        }
        this.cruiseRoomCounts.reservedCount = reservedCount;
        this.cruiseRoomCounts.blockedCount = blockedCount;
        this.cruiseRoomCounts.agencyBlockedCount = agencyBlockedCount;
        this.cruiseRoomCounts.beforeSailCount = beforeSailCount;
        this.cruiseRoomCounts.afterSailCount = afterSailCount;
        this.cruiseRoomCounts.sharedBookedCount = sharedBookedCount;
        this.cruiseRoomCounts.emptyCount = emptyCount;
      }
    },
    filterAgenciesEmail(row, searchTerm){
      let email = row.name;
      // let agency = this.agencyMap[row.agencyId];
      let agency = row;
      let splitSearchTerm = searchTerm.toLowerCase().split(" ");

      let matchCount = 0;
      splitSearchTerm.forEach(searchTerm=> {
        try {
          if (email.includes(searchTerm) || (agency && agency.name.toLowerCase().includes(searchTerm))) {
            matchCount++;
          }
        }catch (e){

        }
      })
      return matchCount === splitSearchTerm.length;
    },
    checkFilter(cruiseRoom){
      let agentMatch = false;
      if(this.selectedAgency !== null){
        if(cruiseRoom.bookingDetail.agentId !== 0) {
          let bookingDetailUser = this.userListMap[cruiseRoom.bookingDetail.agentId];
          let bookingDetailAgency = this.agencyMap[bookingDetailUser.agencyId];

          if(bookingDetailAgency.id === this.selectedAgency){
            agentMatch = true;
          }
        }else if(cruiseRoom.bookingDetail.reservedAgencyId !== 0){
          if(cruiseRoom.bookingDetail.reservedAgencyId === this.selectedAgency){
            agentMatch = true;
          }
        }
      }else{
        agentMatch = true;
      }

      let roomMatch = false;
      if(this.selectedRoom !== null){
        if(cruiseRoom.roomId === this.selectedRoom){
          roomMatch = true;
        }
      }else{
        roomMatch = true;
      }
      return roomMatch && agentMatch;
    },
    resetFilters(){
      this.selectedRoom = null;
      this.selectedAgency = null;
    },
    deckHasRoom(deck){
      let hasRoom = false;
      this.cruiseRoomList.forEach(cruseRoom => {
        if(cruseRoom.deckId === deck.id){
          hasRoom = true;
        }
      });
      return hasRoom;
    },
    // getRoomCellColor(cruiseRoom){
    //   if(cruiseRoom.bookingDetail) {
    //     if (cruiseRoom.bookingDetail.isBooked && cruiseRoom.bookingDetail.bookingId !== 0) {
    //       return "full";
    //     } else if (cruiseRoom.bookingDetail.isBooked && cruiseRoom.bookingDetail.sharedBooked) {
    //       return "sharedBooked";
    //     } else if (cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.sharedBlocked) {
    //       return "sharedBlocked";
    //     } else if (cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.reservedAgencyId === 0) {
    //       return "blocked";
    //     } else if (cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.reservedAgencyId !== 0) {
    //       return "reservedToAgency";
    //     } else if (!cruiseRoom.bookingDetail.isBooked && !cruiseRoom.bookingDetail.blocked) {
    //       return "empty";
    //     }
    //   }
    //
    // },
    getRoomCellType(cruiseRoom){
      if(cruiseRoom.bookingDetail) {
        if (cruiseRoom.bookingDetail.isBooked && cruiseRoom.bookingDetail.bookingId !== 0) {
          return "full";
        } else if ((cruiseRoom.bookingDetail.isBooked && cruiseRoom.bookingDetail.sharedBooked) ||
            (cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.sharedBlocked)) {

          let sharedAvailabilityBookedCount = 0;
          let sharedSailId;
          for (let i = 0; i < cruiseRoom.bookingDetail.sharedAvailabilities.length; i++) {
            if(cruiseRoom.bookingDetail.sharedAvailabilities[i].booked || cruiseRoom.bookingDetail.sharedAvailabilities[i].blocked){
              sharedAvailabilityBookedCount ++;
              sharedSailId = cruiseRoom.bookingDetail.sharedAvailabilities[i].sailId;
            }
          }

          if(sharedAvailabilityBookedCount > 1){
            return "sharedBooked";
          }

          let sharedSailState = 0;
          for (let i = 0; i < this.sharedSails.length; i++) {
            if(this.sharedSails[i].id === sharedSailId){
              sharedSailState = this.sharedSails[i].state;
            }
          }

          if(sharedSailState === 0){
            return "beforeSail";
          }else{
            return "afterSail";
          }

        } else if (cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.reservedAgencyId === 0) {
          return "blocked";
        } else if (cruiseRoom.bookingDetail.blocked && cruiseRoom.bookingDetail.reservedAgencyId !== 0) {
          return "reservedToAgency";
        } else if (!cruiseRoom.bookingDetail.isBooked && !cruiseRoom.bookingDetail.blocked) {
          return "empty";
        }
      }
    },
    detailClick(cruiseRoom){
      let copiedCruiseRoom = {}
      copiedCruiseRoom = JSON.parse(JSON.stringify(cruiseRoom))
      this.$store.commit("setSailDeckRoom",copiedCruiseRoom);
      //TODO WHY DOESN'T WORK ??
      $("#sailDeckPopup").modal("show");
      setTimeout(function (){
        $("#sailDeckPopup").modal("show");
      },5)
    },
    getTitle(cruiseRoom){
      if(!cruiseRoom.bookingDetail){
        return "";
      }
      return "Yolcu Kapasitesi : " + cruiseRoom.bookingDetail.maxGuestCount + "     Oda Tipi : "+ this.roomListMap[cruiseRoom.roomId].name;
    }
  },
  watch: {
    selectedAgency: {
      handler: function () {
        this.onCruiseRoomListChanged();
      }
    },
    selectedRoom: {
      handler: function () {
        this.onCruiseRoomListChanged();
      }
    }
  }
}
</script>

<style scoped>
.reservedToAgency{
  background: darkorange;
  color: white;
}
.sharedBooked{
  background: #f0de38;
  color: white;
}
.beforeSail{
  background: #d13c6f;
  color: white;
}
.afterSail{
  background: #964ba3;
  color: white;
}
.sharedBlocked{
  background: #4b5b52;
  color: white;
}

</style>